const HttpResponse = {
  success: 200,
};

export default HttpResponse;
